import { render, staticRenderFns } from "./ConstanciaNoAdeudo.vue?vue&type=template&id=48fcf2b2"
import script from "./ConstanciaNoAdeudo.vue?vue&type=script&lang=js"
export * from "./ConstanciaNoAdeudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports